/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';

/**
 * 
 * @export
 * @interface ApiSanctionAlertStatusEvent
 */
export interface ApiSanctionAlertStatusEvent {
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionAlertStatusEvent
     */
    id?: number;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiSanctionAlertStatusEvent
     */
    assigner?: ApiAssignmentUser;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionAlertStatusEvent
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionAlertStatusEvent
     */
    statusId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ApiSanctionAlertStatusEvent
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiSanctionAlertStatusEvent
     */
    startTime: Date;
}

/**
 * Check if a given object implements the ApiSanctionAlertStatusEvent interface.
 */
export function instanceOfApiSanctionAlertStatusEvent(value: object): value is ApiSanctionAlertStatusEvent {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function ApiSanctionAlertStatusEventFromJSON(json: any): ApiSanctionAlertStatusEvent {
    return ApiSanctionAlertStatusEventFromJSONTyped(json, false);
}

export function ApiSanctionAlertStatusEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionAlertStatusEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'assigner': json['assigner'] == null ? undefined : ApiAssignmentUserFromJSON(json['assigner']),
        'status': json['status'],
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
        'createdTime': (new Date(json['createdTime'])),
        'startTime': (new Date(json['startTime'])),
    };
}

export function ApiSanctionAlertStatusEventToJSON(json: any): ApiSanctionAlertStatusEvent {
    return ApiSanctionAlertStatusEventToJSONTyped(json, false);
}

export function ApiSanctionAlertStatusEventToJSONTyped(value?: ApiSanctionAlertStatusEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assigner': ApiAssignmentUserToJSON(value['assigner']),
        'status': value['status'],
        'statusId': value['statusId'],
        'createdTime': value['createdTime'].toISOString(),
        'startTime': value['startTime'].toISOString(),
    };
}

